import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-agreement-details',
  templateUrl: './agreement-details.component.html',
  styleUrls: ['./agreement-details.component.css', '../shared/css/common.css']
})
export class AgreementDetailsComponent implements OnInit, OnDestroy {


  @Input()
  showCaptcha: boolean | undefined;
  captcha: string;                              // empty = not yet proven to be a human, anything else = human
  email: string;
  formdata: any;
  payorkey: number;
  orglist: any = [];
  referralTypeList: any = [];
  referralInvolvedTypeList: any = [];
  sitekey: string;
  profileMasterTypeKey: any;
  subjecyTypeId: any;
  uploadsCompleted: boolean = false;
  IsUploadAttatchment: boolean = false;
  uploadFiles: string[] = [];
  primaryColor?: string = "";
  leadData: any;
  suspectFromPreview: string = '';
  suspectToPreview:   string = '';
  private uploadEndDataSub!: Subscription;
  private uploadFileDataSub!: Subscription;

  constructor(
    private agreementFormBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private datePipe: DatePipe
  ) {
    this.captcha = '';
    this.email = 'Secret@email.com';
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "{}");
    this.agreementFormData = this.formdata.agreementDetails;
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.sitekey = environment.capchaSiteKey;

  }

  ngOnInit(): void {
    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {
      this.referralInvolvedTypeList = result.map(x => { return { "value": x.Id, "key": x.Title } });
      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
        this.subjecyTypeId = selectedparty.SubjectTypeKey;
      }
    })

    this.vendorService.getReferringSourcesLookup(this.payorkey).subscribe((result) => {
      this.orglist = result.map(x => { return { "value": x.Id, "key": x.Title } });
    })

    this.vendorService.getReferralTypesLookup(this.payorkey).subscribe((result) => {
      this.referralTypeList = result.map(x => { return { "value": x.Id, "key": x.Title } });
    })

    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      this.IsUploadAttatchment = result.IsUploadAttatchment;
    });

    this.uploadEndDataSub = this.vendorService
      .getUploadEndData()
      .subscribe((data) => {
        if (data) {
            this.leadData.InternalLeadItem.UploadFileNames = this.uploadFiles;
            this.sendReferralEmail(this.leadData);
        }
      });

      
    this.uploadFileDataSub = this.vendorService.getUploadFileData().subscribe((result) => {
      if(result != null && result.length > 0) {
        this.uploadFiles = [];
        result.forEach((item: any)=> {
          this.uploadFiles.push(item.fileName);
        });
      }
      else {
        this.uploadFiles = [];
      }
    });
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.uploadEndDataSub) {
      this.uploadEndDataSub.unsubscribe();
    }

    if (this.uploadFileDataSub) {
      this.uploadFileDataSub.unsubscribe();
    }
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
    console.log('resolved captcha with response: ' + this.captcha);
  }

  agreementForm = this.agreementFormBuilder.group({});
  agreementFormData: any;

  createLocalDate(date?: any): Date | null {
    if (!date) return null;
    if (date instanceof Date) {
      return isNaN(date.getTime()) ? null : date;
    }
    if (typeof date !== 'string') return null;

    const parts = date.split('/');
    if (parts.length !== 3) return null;

    const month = parseInt(parts[0], 10) - 1;
    const day = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if ([month, day, year].some(n => Number.isNaN(n))) return null;
    const d = new Date(year, month, day, 0, 0, 0);
    if (
      d.getFullYear() !== year ||
      d.getMonth() !== month ||
      d.getDate() !== day
    ) {
      return null;
    }

    return d;
  }

  dateOfBirth?:any;
  
  getLocalDate(date?: any): string | null {
    if (!date) return null;
    let d: Date | null = date instanceof Date ? date : new Date(date.trim());
    if (isNaN(d.getTime())) return null;
    return d.toISOString();
  }

  private toBrowserLocalDateTimeWithOffset(value: any): string | null {
    if (!value) return null;
    let d: Date | null = value instanceof Date ? value : new Date(value.trim());
    if (isNaN(d.getTime())) return null;
    const now = new Date();
    d.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);
    return this.toLocalIsoWithOffset(d);
  }

  private buildDateTimes(value: any, submitNow: Date): { localWithOffset: string | null; utcIso: string | null } {
    if (!value) return { localWithOffset: null, utcIso: null };

    let d: Date | null = value instanceof Date ? new Date(value.getTime()) : new Date(value.trim());
    if (isNaN(d.getTime())) return { localWithOffset: null, utcIso: null };

    const isMidnight = d.getHours() === 0 && d.getMinutes() === 0 && d.getSeconds() === 0 && d.getMilliseconds() === 0;
    if (isMidnight) {
      d.setHours(submitNow.getHours(), submitNow.getMinutes(), submitNow.getSeconds(), 0);
    }

    return {
      localWithOffset: this.toLocalIsoWithOffset(d),
      utcIso: d.toISOString()
    };
  }

  private formatAsLocalNoOffsetNoT(value: string | null): string | null {
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
           `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.000`;
  }

    private toLocalIsoWithOffset(d: Date): string {
      d.setMilliseconds(0);
      const pad = (n: number) => String(n).padStart(2, '0');
      const offMinutes = -d.getTimezoneOffset();
      const sign = offMinutes >= 0 ? '+' : '-';
      const abs = Math.abs(offMinutes);
      const hh = pad(Math.floor(abs / 60));
      const mm = pad(abs % 60);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T` +
            `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}` +
            `${sign}${hh}:${mm}`;
  }

  private getUtcNoOffsetString(localIsoWithOffset: string | null): string | null {
    if (!localIsoWithOffset) return null;
    const d = new Date(localIsoWithOffset);
    if (isNaN(d.getTime())) return null;
    const pad = (n: number) => String(n).padStart(2, '0');

    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ` +
          `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}.000`;
  }

  agreementDetailsSubmit() {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "{}");
    this.formdata.agreementDetails = this.agreementFormData;

    let sourceCode = "";
    let namePrefix = "";
    let firstName = "";
    let middleName = "";
    let lastName = "";
    let nameSuffix = "";
    let designation = "";
    let ssn = "";
    let licenceNumber = "";
    let manualSubjectID = "";
    let npi = "";
    let tin = "";
    let medicaidId = "";
    let medicareId = "";
    let otherId = "";
    let providerType = "";
    let ProviderSpecialty = "";
    let taxonomyId = "";
    let other = "";
    let streetAddress1 = "";
    let streetAddress2 = "";
    let city = "";
    let state = "";
    let county = "";
    let zip = "";
    let country = "";
    let phone = "";
    let secondaryPhone = "";
    let fax = "";
    let email = "";
    let gender = "";
    let plan = "";
    let program = "";
    let lob = "";
    let group = "";
    let contactNamePrefix = "";
    let contactFirstName = "";
    let contactMiddleName = "";
    let contactLastName = "";
    let contactDesignation = "";
    let associatedOrganizationName = "";



    switch (this.profileMasterTypeKey) {
      case 1:
        sourceCode = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pOrgName").value;
        namePrefix = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pNamePrefix").value;
        firstName = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pFirstName").value;
        middleName = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pMiddleName").value;
        lastName = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pLastName").value;
        nameSuffix = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pNameSuffix").value;
        designation = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pDesignation").value;
        this.dateOfBirth = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pDateOfBirth").value;
        ssn = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pSsn").value;
        licenceNumber = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pLicenseNo").value;
        manualSubjectID = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pProviderID").value;
        npi = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pNPInumber").value;
        tin = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pTIN").value;
        medicaidId = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pMedicaidId").value;
        medicareId = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pMedicareId").value;
        otherId = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pOtherId").value;
        providerType = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pType").value;
        ProviderSpecialty = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pSpecialty").value;
        taxonomyId = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pTaxonomy").value;
        other = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pOther").value;
        streetAddress1 = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress1").value;
        streetAddress2 = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pStreetAddress2").value;
        city = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCity").value;
        state = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pState").value;
        county = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCounty").value;
        zip = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pZip").value;
        country = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pCountry").value;
        phone = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pPhone").value;
        fax = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pFax").value;
        email = this.formdata.providerDetails.controls.find((x: { name: any; }) => x.name == "pEmail").value;
        break;
      case 2:
        namePrefix = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mNamePrefix").value;
        firstName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mFirstName").value;
        middleName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mMiddleName").value;
        lastName = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mLastName").value;
        nameSuffix = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mNameSuffix").value;
        this.dateOfBirth = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mDateOfBirth").value;
        gender = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mGender").value;
        other = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mOther").value;
        manualSubjectID = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mID").value;
        ssn = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mSSN").value;
        medicaidId = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mMedicaidId").value;
        medicareId = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mMedicareId").value;
        otherId = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mOtherId").value;
        plan = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mPlan").value;
        program = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mProgram").value;
        lob = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mLOB").value;
        group = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mGroup").value;
        streetAddress1 = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mAddress1").value;
        streetAddress2 = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mAddress2").value;
        city = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mCity").value;
        state = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mState").value;
        county = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mCounty").value;
        zip = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mZip").value;
        phone = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mPrimaryPhone").value;
        secondaryPhone = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mSecondaryPhone").value;
        email = this.formdata.memberDetails.controls.find((x: { name: any; }) => x.name == "mEmail").value;
        break;
      case 3:
        sourceCode = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepOrgName").value;
        namePrefix = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepNamePrefix").value;
        firstName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepFirstName").value;
        middleName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepMiddleName").value;
        lastName = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepLastName").value;
        nameSuffix = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepNameSuffix").value;
        designation = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepDesignation").value;
        this.dateOfBirth = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepDateOfBirth").value;
        ssn = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepSsn").value;
        licenceNumber = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepLicenseNo").value;
        otherId = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepOtherId").value;
        other = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepOther").value;
        phone = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepPrimaryPhone").value;
        secondaryPhone = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepSecondaryPhone").value;
        fax = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepFax").value;
        email = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepEmail").value;
        streetAddress1 = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepStreetAddress2").value;
        city = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCity").value;
        state = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepState").value;
        county = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCounty").value;
        zip = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepZip").value;
        country = this.formdata.nonEnumeratedProviderDetails.controls.find((x: { name: any; }) => x.name == "nepCountry").value;
        break;
      case 4:
        sourceCode = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOrgName").value;
        tin = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoTIN").value;
        licenceNumber = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoLicenseNo").value;
        other = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOther").value;
        otherId = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoOtherId").value;
        contactNamePrefix = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactNamePrefix").value;
        contactFirstName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactFirstName").value;
        contactMiddleName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactMiddleName").value;
        contactLastName = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactLastName").value;
        contactDesignation = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoContactDesignation").value;
        streetAddress1 = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoStreetAddress2").value;
        city = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCity").value;
        state = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoState").value;
        county = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCounty").value;
        zip = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoZip").value;
        country = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoCountry").value;
        phone = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoPhone").value;
        fax = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoFax").value;
        email = this.formdata.nonEnumeratedOrganizationDetails.controls.find((x: { name: any; }) => x.name == "neoEmail").value;
        break;
      case 5:
        namePrefix = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiNamePrefix").value;
        firstName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiFirstName").value;
        middleName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiMiddleName").value;
        lastName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiLastName").value;
        nameSuffix = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiNameSuffix").value;
        designation = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiDesignation").value;
        this.dateOfBirth = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiDateOfBirth").value;
        ssn = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiSsn").value;
        otherId = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiOtherId").value;
        other = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiOther").value;
        streetAddress1 = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress1").value;
        streetAddress2 = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiStreetAddress2").value;
        city = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiCity").value;
        state = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiState").value;
        county = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiCounty").value;
        zip = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiZip").value;
        country = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiCountry").value;
        phone = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiPrimaryPhone").value;
        secondaryPhone = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiSecondaryPhone").value;
        email = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiEmail").value;
        associatedOrganizationName = this.formdata.nonEnumeratedIndividualDetails.controls.find((x: { name: any; }) => x.name == "neiAssociatedOrg").value;
        break;
    }

    this.dateOfBirth = this.dateOfBirth == null ? null : this.datePipe.transform(this.createLocalDate(this.datePipe.transform(this.dateOfBirth, "MM/dd/yyyy")));
    const det = this.formdata.witnessDetails.controls.find((x: any) => x.name == "originalDetectionDt")?.value;
    const start = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentStartDt")?.value;
    const end = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentEndDt")?.value;
    const suspectStart = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentStartDt")?.value;
    const suspectEnd = this.formdata.witnessDetails.controls.find((x: any) => x.name == "incidentEndDt")?.value;
    const submitNow = new Date();
    const detDt       = this.buildDateTimes(det, submitNow);
    const startDt     = this.buildDateTimes(start, submitNow);
    const endDt       = this.buildDateTimes(end, submitNow);
    const suspectFromDt = this.buildDateTimes(suspectStart, submitNow);
    const suspectToDt   = this.buildDateTimes(suspectEnd, submitNow);
    this.suspectFromPreview = this.formatAsLocalNoOffsetNoT(suspectFromDt.localWithOffset) || '—';
    this.suspectToPreview   = this.formatAsLocalNoOffsetNoT(suspectToDt.localWithOffset)   || '—';
    const participantDobRaw = this.formdata.participantDetails.controls.find((x: { name: any }) => x.name == "paDOB")?.value;
    const participantDobFormatted = participantDobRaw == null ? null : this.datePipe.transform( this.createLocalDate(this.datePipe.transform(participantDobRaw, 'MM/dd/yyyy')), 'MMM d yyyy');
    var data = {
      
      //userDetails
      FirstName: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "firstName")?.value,
      LastName: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "lastName")?.value,
      OrganizationId: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "orgName")?.value,
      OrganizationName: this.orglist.find((xy: { value: any; }) => xy.value == this.formdata.userDetails.controls.find((xy: any) => xy.name == "orgName")?.value)?.key,
      Relationship: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "title")?.value,
      Tilte: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "title")?.value,
      Phone: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "phone")?.value,
      Email: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "email")?.value,
      Address1: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "address1")?.value,
      Address2: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "address2")?.value,
      City: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "city")?.value,
      State: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "state")?.value,
      ZipCode: this.formdata.userDetails.controls.find((x: { name: any; }) => x.name == "zip")?.value,

      //referal
      LeadReasons: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType")?.value,
      ReferalType: this.referralTypeList.find((xz: { value: any; }) => xz.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType").value)?.key,
      ReferalTypeId: this.referralTypeList.find((xz: { value: any; }) => xz.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referalType").value)?.value,
      ReferalInvolvedType: this.referralInvolvedTypeList.find((xw: { value: any; }) => xw.value == this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "involvedType").value)?.key,
      InvolvedPartyTypeId: this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value,
      ReferalTrackingNumber: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "trackingNumber")?.value,
      AlternateId: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "trackingNumber")?.value,
      ReferalDetected: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "detected")?.value,
      ReferalEstimatedAmount: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "estimatedAmount")?.value,
      ReferalOriginalDetectionDt: this.getUtcNoOffsetString(detDt.localWithOffset),
      ReferalIncidentStartDt:     this.getUtcNoOffsetString(startDt.localWithOffset),
      ReferalIncidentEndDt:       this.getUtcNoOffsetString(endDt.localWithOffset),
      SuspectActivityFrom:        this.getUtcNoOffsetString(suspectFromDt.localWithOffset),
      SuspectActivityTo:          this.getUtcNoOffsetString(suspectToDt.localWithOffset),
      ReferalState: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "state")?.value,
      ReferalCounty: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "county")?.value,
      ReferralSummary: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "referralSummary")?.value,
      associatedLeadReasonId: this.formdata.witnessDetails.controls.find((x: { name: any; }) => x.name == "associatedLeadReasonId")?.value,

      //witness
      WitnessExternalReferal: this.formdata.extenalReferall.controls.find((x: { name: any; }) => x.name == "isExternalReferal")?.value,
      WitnesFirstName: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wFirstName")?.value,
      WitnesLastName: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wLastName")?.value,
      WitnesAgencyName: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wAgencyName")?.value,
      WitnesPhone: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "phone")?.value,
      WitnesEmail: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "email")?.value,
      WitnessRelation: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wRelationShip")?.value,
      WitnessAddress1: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wAddress1")?.value,
      WitnessAddress2: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "wAddress2")?.value,
      WitnessCity: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "city")?.value,
      WitnessState: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "state")?.value,
      WitnessZip: this.formdata.extenalReferall.subcontrols.find((x: { name: any; }) => x.name == "zip")?.value,

      //subject
      SubjectTypeKey: this.subjecyTypeId,
      SubjectOrganizationName: sourceCode,
      SubjectNamePrefix: namePrefix,
      SubjectFirstName: firstName,
      SubjectMiddleName: middleName,
      SubjectLastName: lastName,
      SubjectNameSuffix: nameSuffix,
      SubjectDesignation: designation,
      SubjectDateOfBirth: this.dateOfBirth,
      SubjectSsn: ssn,
      SubjectLicenceNumber: licenceNumber,
      SubjectManualSubjectId: manualSubjectID,
      SubjectNpi: npi,
      SubjectTin: tin,
      SubjectMedicaidId: medicaidId,
      SubjectMedicareId: medicareId,
      SubjectOtherId: otherId,
      SubjectProviderType: providerType,
      SubjectProviderSpecialty: ProviderSpecialty,
      SubjectTaxonomyId: taxonomyId,
      SubjectOther: other,
      SubjectStreetAddress1: streetAddress1,
      SubjectStreetAddress2: streetAddress2,
      SubjectCity: city,
      SubjectState: state,
      SubjectCounty: county,
      SubjectZip: zip,
      SubjectCountry: country,
      SubjectPhone: phone,
      SubjectSecondaryPhone: secondaryPhone,
      SubjectFax: fax,
      SubjectEmail: email,
      SubjectGender: gender,
      SubjectPlan: plan,
      SubjectProgram: program,
      SubjectLob: lob,
      SubjectGroup: group,
      SubjectContactNamePrefix: contactNamePrefix,
      SubjectContactFirstName: contactFirstName,
      SubjectContactMiddleName: contactMiddleName,
      SubjectContactLastName: contactLastName,
      SubjectContactDesignation: contactDesignation,
      SubjectAssociatedOrganizationName: associatedOrganizationName,
      ProfileMasterTypeKey: this.profileMasterTypeKey,


      //SpecificPatient
      SpecificPatient: this.formdata.validateParticipant.controls.find((x: { name: any; }) => x.name == "vpIsParticipant").value,
      
      SameWitnessReferringParty: this.formdata.validateParticipant.subcontrols.find((x: { name: any; }) => x.name == "vpIsreferring").value,

      ParticipantFirstName: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paFirstName")?.value,
      ParticipantLastName: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paLastName")?.value,
      ParticipantId: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paID")?.value,
      ParticipantDOB: participantDobFormatted,
      ParticipantPlanType: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paPlanType")?.value,
      ParticipantAdd1: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paAddress1")?.value,
      ParticipantAdd2: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paAddress2")?.value,
      ParticipantCity: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paCity")?.value,
      ParticipantState: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paState")?.value,
      ParticipantCounty: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paCounty")?.value,
      ParticipantZip: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paZip")?.value,
      ParticipantCountry: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paCountry")?.value,
      ParticipantPhone: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paPhone")?.value,
      ParticipantEmail: this.formdata.participantDetails.controls.find((x: { name: any; }) => x.name == "paEmail")?.value,

      //Question
      QuestionList: this.formdata.questionsDetails.controls,

      FCReferralJson: JSON.stringify(this.formdata),
      TimeZoneUtcDifference: (new Date()).getTimezoneOffset(),

      Description: this.formdata.summaryDetails.controls[0].value,
      LeadTypeId: this.subjecyTypeId,

      //Upload files
      UploadFileNames: this.uploadFiles

    }
    this.vendorService.createLead(this.payorkey, data).subscribe((result) => {
      if (result.IsSuccess) {
        this.leadData = result;
        if (!this.IsUploadAttatchment) {
          this.sendReferralEmail(result);
        }
        else {
          this.vendorService.sendUploadStartData(result);
        }
      } else {
        sessionStorage.removeItem("activeformdata");
        this.router.navigateByUrl("/" + (sessionStorage.getItem("securityCode") ?? ""));
      }

    }, error => { });

  }

  sendReferralEmail(result: any) {
    var param = {
        lead: result.InternalLeadItem,
        payorkey: this.payorkey,
        leadid: result.LeadId,
        leadKeyForResult: result.LeadKey,
        caseActivityKeyForResult: result.CaseActivityKey,
    }
    this.vendorService.sendReferralEmail(param).subscribe((res) => {
      this.router.navigate(['final']);
    });
  }

  back() {
    this.formdata.agreementDetails = this.agreementFormData;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
    this.router.navigate(['summary']);
  }

  captchaEvent(captcha: string) {
    this.captcha = captcha;
  }


}
